import React from 'react'

export default function Events() {
  return (
    <div className="screen-container">Events</div>
  )
}
